import withAuthentication from '@alphapoint/apex-web/lib/hocs/withAuthentication';
import React from 'react';
import { getBEMClasses } from '../helpers/cssClassesHelper';
import PageFooterLayout from '../layouts/PageFooterLayout/PageFooterLayout';
import PageSubHeaderLayout from '../layouts/PageSubHeaderLayout/PageSubHeaderLayout';

import MarketDataCardsContainer from '@alphapoint/apex-web/lib/components/MarketDataCardsComponent/MarketDataCardsContainer';

const layoutClasses = getBEMClasses('dashboard-page');

const MarketDataPage = () => (
  <React.Fragment>
    <div className={layoutClasses('accent-bar')} />
    <PageSubHeaderLayout />
    <div className={layoutClasses()}>
      <MarketDataCardsContainer />
    </div>
    <div className={layoutClasses('footer')}>
      <PageFooterLayout />
    </div>
  </React.Fragment>
);

export default withAuthentication(MarketDataPage);
